<template>
    <Component
        :is="component"
        :to="isActive ? '' : `/catalog/${product.slug}`"
        target="_blank"
        :class="[
            isActive
                ? 'cursor-default bg-white shadow-[0_0_2rem_0] shadow-accent'
                : 'hover:bg-white/20',
        ]"
        class="group flex items-center gap-3 rounded-8 transition-all duration-300">
        <div
            class="flex size-25 flex-shrink-0 items-center justify-center overflow-hidden rounded-8 bg-white p-1 lg:size-16 xl:size-36">
            <picture class="h-full w-full object-contain">
                <source
                    v-if="product.images?.[0]?.webp_url"
                    type="image/webp"
                    :srcset="
                        getMediaLink(
                            product.images?.[0]?.webp_url || '',
                            400
                        ) || ''
                    " />

                <source
                    v-else-if="
                        !product.images?.[0]?.webp_url &&
                        !product.images?.[0]?.url
                    "
                    type="image/webp"
                    srcset="/assets/images/ui/placeholder/webp/cromi.webp" />

                <img
                    :alt="product.images?.[0]?.alt || undefined"
                    :src="
                        getMediaLink(product.images?.[0]?.url || '', 400) ||
                        '/assets/images/ui/placeholder/jpg-png/cromi.png'
                    "
                    class="h-full w-full object-contain" />
            </picture>
        </div>

        <div class="flex max-w-48 flex-col overflow-hidden">
            <h3
                :class="isActive ? 'text-accent' : 'text-gray-200'"
                class="text-20/100 font-semibold leading-snug">
                {{ product.name }}
            </h3>
        </div>
    </Component>
</template>

<script setup lang="ts">
import type { IProductCard } from '~/components/particles/product-card/product-card.types'

interface Props {
    isActive: boolean
    product: IProductCard
}

const props = defineProps<Props>()

const component = computed(() => {
    return props.isActive ? 'div' : resolveComponent('NuxtLink')
})
</script>
